import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getSchedulingPerformanceOverview,
  type SchedulingPerformanceOverviewResult,
} from '@services/api/dashboard/scheduling-performance.api'

export function useSchedulingPerformanceOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<SchedulingPerformanceOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(
    queryParams,
    getSchedulingPerformanceOverview,
    { enabled, queued },
  )
}
